/*
 * The suggestions under the header search box, on Algolia Autocomplete v1 (autocomplete-core).
 *
 * The core keeps the state and the keyboard handling; this file renders the markup the dropdown had
 * under autocomplete.js 0.x, class for class, so the theme's stylesheet and the browser suite in
 * shopify-theme-e2e keep applying. The dropdown stays a dropdown on phones. Only book suggestions
 * are rendered, not collections or articles.
 */
(function () {
  "use strict";

  var core = window.awSearch;
  var autocompleteCore = window["@algolia/autocomplete-core"];
  if (!core || !autocompleteCore) return;
  var config = core.config;

  var inputs = document.querySelectorAll(config.input_selector);
  if (inputs.length === 0) return;

  var HITS_PER_PAGE = config.products_autocomplete_hits_per_page;
  // The engine marks matches with these; the text is escaped first and the marks become spans.
  var HIGHLIGHT_PRE = "__aw-highlight__";
  var HIGHLIGHT_POST = "__/aw-highlight__";

  var searchClient = core.createSearchClient();
  var _escape = core.escape;

  var _highlighted = function (field) {
    return _escape(field && field.value)
      .split(HIGHLIGHT_PRE)
      .join('<span class="aa-highlight">')
      .split(HIGHLIGHT_POST)
      .join("</span>");
  };

  var _highlightedValues = function (field) {
    if (!field) return [];
    return (Array.isArray(field) ? field : [field]).map(_highlighted);
  };

  // "A", "A und B", "A, B und C".
  var _joinNames = function (names) {
    if (names.length <= 1) return names.join("");
    return names.slice(0, -1).join(", ") + " und " + names[names.length - 1];
  };

  var _productUrl = function (item) {
    return (
      core.urlPrefix +
      "/products/" +
      item.handle +
      (String(item.objectID) !== String(item.id) ? "?variant=" + item.objectID : "")
    );
  };

  // Quotes, brackets, backslashes and spaces would end the CSS url() the address sits in.
  var _cssUrl = function (url) {
    return url.replace(/['"()\\\s]/g, function (character) {
      return "%" + character.charCodeAt(0).toString(16).toUpperCase();
    });
  };

  var _has = function (object, key) {
    return Object.prototype.hasOwnProperty.call(object, key);
  };

  // known: what Shopify answered so far for this box, by product id (search_core.js lookUpProducts);
  // false for a product that no longer exists or is not sold in the visitor's market.
  var _productMarkup = function (item, known) {
    var product = known[String(item.id)];
    var tags = item.named_tags || {};
    var highlight = item._highlightResult || {};
    var highlightedTags = highlight.named_tags || {};
    var publisher = tags.publisher ? " | " + _highlighted(highlightedTags.publisher) : "";
    var info = "";
    if (tags["prod-version"] === "v2.1") {
      info =
        '<p class="aa-product-info">' +
        (item.product_type ? _highlighted(highlight.product_type) + " " : "") +
        _highlightedValues(highlightedTags.onix_contrib)
          .map(function (name) {
            return "von " + name;
          })
          .join(", ") +
        publisher +
        "</p>";
    } else if (tags["prod-version"] === "v3.0") {
      var authors = _highlightedValues(highlightedTags.onix_contrib_author);
      var translators = _highlightedValues(highlightedTags.onix_contrib_translator);
      info =
        '<p class="aa-product-info">' +
        (authors.length ? "von " + _joinNames(authors) : "") +
        publisher +
        "</p>" +
        (translators.length
          ? '<p class="aa-product-info">übersetzt von ' + _joinNames(translators) + "</p>"
          : "");
    }
    return (
      '<div class="aa-product">' +
      '<div class="aa-product-picture" style="background-image: url(\'' +
      _escape(_cssUrl(core.sizedImage((product && product.image) || item.image, "thumb"))) +
      "')\"></div>" +
      '<div class="aa-product-text">' +
      '<p class="aa-product-title">' +
      _highlighted(highlight.title) +
      "</p>" +
      info +
      '<p class="aa-sku">' +
      _highlighted(highlight.sku) +
      "</p>" +
      _priceMarkup(item, known) +
      "</div>" +
      "</div>"
    );
  };

  // In a secondary market the price shows only once Shopify has answered: no price rather than a
  // wrong one. In the primary market the record's price shows until then.
  var _priceMarkup = function (item, known) {
    var product = known[String(item.id)];
    var answered = Boolean(product);
    var hidden = core.secondaryMarket && !answered;
    // The price of the format the suggestion links to, or the lowest when Shopify no longer lists it.
    var variant = answered ? product.variants[String(item.objectID)] : null;
    return (
      '<p class="aa-product-price' +
      (answered ? " algolia-price-updated" : "") +
      '"' +
      (hidden ? ' style="visibility: hidden;"' : "") +
      ">" +
      core.price(answered ? (variant ? variant.price : product.price) : item.price) +
      "</p>"
    );
  };

  var _footerMarkup = function (query, nbHits) {
    var searched = core.normalizeQuery(query);
    return (
      '<div class="aa-footer"><a class="aa-footer-link" href="' +
      _escape(core.urlPrefix + "/search?q=" + encodeURIComponent(searched)) +
      '">Alle Suchergebnisse für <span class="aa-query">"' +
      _escape(query) +
      '"</span></a> (' +
      (core.countIsEstimated(searched) ? "ca. " : "") +
      '<span class="aa-nbhits">' +
      _escape(nbHits) +
      "</span>)</div>"
    );
  };

  var _emptyMarkup = function (query) {
    return (
      '<div class="aa-products-empty"><p class="aa-no-result">Keine Suchergebnisse für "' +
      _escape(query) +
      '"</p><p class="aa-see-all"><a href="' +
      _escape(core.urlPrefix + "/search?q=") +
      '">Alle Bücher anzeigen</a></p></div>'
    );
  };

  // The left column holds the app's collection and article sections, which the stylesheet hides
  // through the aa-without-* classes; it stays so the columns keep their widths.
  var LEFT_COLUMN =
    '<div class="aa-left-column"><div class="aa-collections"><div class="aa-collections-header">Collections</div>' +
    '<div class="aa-dataset-collections"></div></div><div class="aa-articles"><div class="aa-articles-header">' +
    'Blog posts</div><div class="aa-dataset-articles"></div></div></div>';

  // Copies the aria, id and role attributes from one of the core's prop objects onto an element; its
  // event handlers are wired separately. aria-labelledby is left out: the core names a label element
  // the header form does not have, and the box carries its own aria-label.
  var _attributes = function (element, props, keepId) {
    Object.keys(props).forEach(function (name) {
      var value = props[name];
      if (typeof value === "function" || name === "aria-labelledby") return;
      if (name === "id" && keepId) return;
      if (name.indexOf("aria-") !== 0 && name !== "id" && name !== "role") return;
      if (value === undefined || value === null || value === false) element.removeAttribute(name);
      else element.setAttribute(name, String(value));
    });
  };

  var _setUp = function (input, number) {
    var wrapper = document.createElement("span");
    wrapper.className = "algolia-autocomplete";
    wrapper.style.position = "absolute";
    wrapper.style.display = "none";
    document.body.appendChild(wrapper);
    input.classList.add("aa-input");
    input.setAttribute("role", "combobox");
    // autocomplete off keeps the browser's own search history from covering the suggestions; the
    // other three keep phone keyboards from correcting or capitalising a title, author or ISBN.
    input.setAttribute("autocomplete", "off");
    input.setAttribute("autocorrect", "off");
    input.setAttribute("autocapitalize", "off");
    input.setAttribute("spellcheck", "false");

    // The dropdown re-renders on every keystroke, hover and arrow key; each product is asked about
    // once, and the answer is kept and used in every later render.
    var known = {};
    var askedFor = {};

    var _lookUp = function (items) {
      var productIds = items
        .map(function (item) {
          return String(item.id);
        })
        .filter(function (productId) {
          return !_has(askedFor, productId);
        });
      if (productIds.length === 0) return;
      productIds.forEach(function (productId) {
        askedFor[productId] = true;
      });
      core.lookUpProducts(productIds).then(function (products) {
        // A failed request changes nothing; it is not repeated for the same products.
        if (products === null) return;
        productIds.forEach(function (productId) {
          known[productId] = products[productId] || false;
        });
        if (!lastState) return;
        // A book the shop no longer has leaves the dropdown's own list too, so the arrow keys and
        // Enter cannot reach it.
        var collection = lastState.collections[0];
        var kept = collection
          ? collection.items.filter(function (item) {
              return known[String(item.id)] !== false;
            })
          : [];
        if (collection && kept.length !== collection.items.length) {
          autocomplete.setActiveItemId(null);
          autocomplete.setCollections([{ source: collection.source, items: kept }]);
        } else {
          _render(lastState);
        }
      });
    };

    // Places the dropdown under the box: as wide as the box when that is wide, otherwise centred
    // with at least a quarter of the window on either side.
    var _place = function () {
      var rect = input.getBoundingClientRect();
      var viewportWidth = document.body.clientWidth;
      var left = rect.left + window.scrollX;
      var right = viewportWidth - rect.width - left;
      var align = left < right ? "left" : "right";
      var distance = Math.min(left, right);
      if (4 * distance > viewportWidth) {
        align = "left";
        distance = Math.round(viewportWidth / 4);
      }
      var width = viewportWidth - 2 * distance;
      if (rect.width >= 600) {
        align = "left";
        distance = left;
        width = rect.width;
      }
      wrapper.style.top = rect.bottom + window.scrollY + "px";
      wrapper.style.left = "";
      wrapper.style.right = "";
      wrapper.style[align] = distance + "px";
      wrapper.style.width = width + "px";
      var size = width < 300 ? "xs" : width < 600 ? "sm" : width < 900 ? "md" : "lg";
      return "aa-dropdown-menu-size-" + size;
    };

    var autocomplete;
    // The state the dropdown shows; item events look their item up in it.
    var lastState = null;
    var _render = function (state) {
      lastState = state;
      // The box keeps its own id, which the theme's stylesheet and scripts use.
      _attributes(input, autocomplete.getInputProps({ inputElement: input }), true);
      input.setAttribute("aria-expanded", String(Boolean(state.isOpen && state.query)));
      if (!state.isOpen || !state.query) {
        wrapper.style.display = "none";
        wrapper.innerHTML = "";
        return;
      }
      var collection = state.collections[0];
      var items = collection ? collection.items : [];
      var sizeClass = _place();
      var dataset;
      if (items.length) {
        var nbHits = items[0].__nbHits || 0;
        dataset =
          '<span class="aa-suggestions" style="display: block;">' +
          items
            .map(function (item, index) {
              return (
                '<div class="aa-suggestion' +
                (state.activeItemId === item.__autocomplete_id ? " aa-cursor" : "") +
                '" data-index="' +
                index +
                '" data-id="' +
                _escape(item.id) +
                '">' +
                _productMarkup(item, known) +
                "</div>"
              );
            })
            .join("") +
          "</span>" +
          (nbHits > HITS_PER_PAGE ? _footerMarkup(state.query, nbHits) : "");
      } else if (state.status === "idle") {
        dataset = _emptyMarkup(state.query);
      } else {
        return;
      }
      wrapper.innerHTML =
        '<span class="aa-dropdown-menu ' +
        (items.length ? "aa-with-products " : "aa-without-products ") +
        sizeClass +
        '" style="display: block;">' +
        '<div class="aa-columns-container aa-without-articles aa-without-collections aa-without-powered-by aa-with-products">' +
        '<div class="aa-dataset-products aa-right-column">' +
        dataset +
        "</div>" +
        LEFT_COLUMN +
        "</div></span>";
      wrapper.style.display = "block";

      var menu = wrapper.querySelector(".aa-dropdown-menu");
      if (collection) _attributes(menu, autocomplete.getListProps({ source: collection.source }));
      wrapper.querySelectorAll(".aa-suggestion").forEach(function (element) {
        var item = items[Number(element.getAttribute("data-index"))];
        _attributes(element, autocomplete.getItemProps({ item: item, source: collection.source }));
      });
      if (items.length) _lookUp(items);
    };

    autocomplete = autocompleteCore.createAutocomplete({
      id: "aw-search-" + number,
      // The privacy policy promises no tracking.
      insights: false,
      openOnFocus: false,
      // The dropdown also opens to say that nothing matched.
      shouldPanelOpen: function (params) {
        return params.state.query.length > 0;
      },
      onStateChange: function (params) {
        _render(params.state);
      },
      getSources: function (params) {
        var query = core.normalizeQuery(params.query);
        if (!query) return [];
        return [
          {
            sourceId: "products",
            getItems: function () {
              return searchClient
                .search([
                  {
                    indexName: core.productsIndex,
                    params: {
                      query: query,
                      hitsPerPage: HITS_PER_PAGE,
                      distinct: true,
                      facetingAfterDistinct: false,
                      highlightPreTag: HIGHLIGHT_PRE,
                      highlightPostTag: HIGHLIGHT_POST,
                    },
                  },
                ])
                .then(function (response) {
                  var result = response.results[0];
                  // A book Shopify has already reported gone is not suggested again.
                  return (
                    result.hits
                      // On Meilisearch a one-word search's exact matches come on top of a full page.
                      .slice(0, HITS_PER_PAGE)
                      .filter(function (hit) {
                        return known[String(hit.id)] !== false;
                      })
                      // The count travels with its own hits, so a late answer cannot pair one
                      // query's count with another query's suggestions.
                      .map(function (hit) {
                        return Object.assign({}, hit, { __nbHits: result.nbHits });
                      })
                  );
                });
            },
            getItemUrl: function (itemParams) {
              return _productUrl(itemParams.item);
            },
            // The Enter key navigates by itself; a click only selects.
            onSelect: function (selectParams) {
              if (selectParams.event && selectParams.event.type === "click") {
                window.location.assign(selectParams.itemUrl);
              }
            },
          },
        ];
      },
    });

    var _props = function () {
      return autocomplete.getInputProps({ inputElement: input });
    };
    input.addEventListener("input", function (event) {
      _props().onChange(event);
    });
    input.addEventListener("compositionend", function (event) {
      _props().onCompositionEnd(event);
    });
    input.addEventListener("keydown", function (event) {
      _props().onKeyDown(event);
    });
    input.addEventListener("focus", function (event) {
      _props().onFocus(event);
    });
    input.addEventListener("click", function (event) {
      _props().onClick(event);
    });

    // Items are re-rendered on every state change, so their handlers are delegated from the wrapper.
    var _itemHandler = function (name) {
      return function (event) {
        var element = event.target.closest(".aa-suggestion");
        if (!element || !wrapper.contains(element)) return;
        var collection = lastState && lastState.collections[0];
        if (!collection) return;
        var item = collection.items[Number(element.getAttribute("data-index"))];
        if (!item) return;
        autocomplete.getItemProps({ item: item, source: collection.source })[name](event);
      };
    };
    wrapper.addEventListener("mousemove", _itemHandler("onMouseMove"));
    wrapper.addEventListener("mousedown", _itemHandler("onMouseDown"));
    wrapper.addEventListener("click", _itemHandler("onClick"));
    wrapper.addEventListener("mousedown", function (event) {
      autocomplete.getPanelProps({}).onMouseDown(event);
    });
    wrapper.addEventListener("mouseleave", function () {
      autocomplete.getPanelProps({}).onMouseLeave();
    });

    // A press or touch outside the box and the dropdown closes it.
    var _environment = function () {
      return autocomplete.getEnvironmentProps({
        inputElement: input,
        formElement: input.form || input,
        panelElement: wrapper,
      });
    };
    window.addEventListener("mousedown", function (event) {
      _environment().onMouseDown(event);
    });
    window.addEventListener("touchstart", function (event) {
      _environment().onTouchStart(event);
    });
    window.addEventListener("touchmove", function (event) {
      _environment().onTouchMove(event);
    });
    window.addEventListener("resize", function () {
      if (wrapper.style.display === "none") return;
      var menu = wrapper.querySelector(".aa-dropdown-menu");
      var sizeClass = _place();
      if (!menu) return;
      ["xs", "sm", "md", "lg"].forEach(function (size) {
        menu.classList.toggle(
          "aa-dropdown-menu-size-" + size,
          sizeClass === "aa-dropdown-menu-size-" + size,
        );
      });
    });
  };

  Array.prototype.forEach.call(inputs, _setUp);
})();
